export const CANCELLATION_DISCLAIMER_TEXT =
  'By checking this box, I acknowledge that I am submitting a claim for a previously cancelled policy. If the loss is verified to have occurred prior to the cancellation date, the policy will be reinstated in order for the claim to be processed. In the event that the claim is denied, I will be required to complete the cancellation process within the Portal again.';

export const CLAIM_TRUTH_ACK_TEXT =
  'By checking this box, I acknowledge that the information I have entered in this form is true to the best of my knowledge.';

export const SUBROGATION_ACK_TEXT =
  'By checking this box, you are acknowledging that the Insurer will automatically have rights of subrogation in respect of such Loss payment(s) against the Resident(s) and the Lease cosigner and/or responsible party(ies).';

export const clearedCancellationDisclaimerFields = () => ({
  showCancellationDisclaimer: false,
  cancellationAcknowledgementDateTime: null,
  cancellationDisclaimerAcknowledged: false,
});

export const cancellationDisclaimerFieldsFromPolicy = (policy) => ({
  showCancellationDisclaimer: Boolean(policy?.showCancellationDisclaimer),
  cancellationAcknowledgementDateTime: policy?.cancellationAcknowledgementDateTime || null,
  cancellationDisclaimerAcknowledged: false,
});
